import React, { useState, createContext, useEffect } from "react";

export const NavContext = createContext();

export const NavProvider = (props) => {
  const [activeIndex, setActiveIndex] = useState("home");
  const [isSideBarActive, setIsSideBarActive] = useState(false);

  useEffect(() => {
    console.log(`changed to ${activeIndex}`);
  }, [activeIndex]);

  return (
    <NavContext.Provider
      value={{
        activeIndex,
        setActiveIndex,
        isSideBarActive,
        setIsSideBarActive,
      }}
    >
      {props.children}
    </NavContext.Provider>
  );
};
